import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import MainLayout from '../layout/MainLayout'

const ProtectedRoute = ({ isAdmin }) => {
  const navigate = useNavigate()
  const { isAuthenticated, user, loading } = useSelector((state) => state.user)

  useEffect(() => {
    if (loading) return

    if (!isAuthenticated) {
      navigate('/login')
      return
    }

    if (isAdmin && user?.role !== 'admin') {
      navigate('/login')
    }
  }, [isAdmin, isAuthenticated, user, loading, navigate])

  if (loading || !isAuthenticated) {
    return null
  }

  return <MainLayout />
}

export default ProtectedRoute
